import React, { useEffect, useState } from 'react';
import api from '../api';

const defaultForm = {
  eventCode: '',
  title: '',
  description: '',
  startDate: '',
  endDate: '',
  days: '',
  locationName: '',
  locationAddress: '',
  city: '',
  province: '',
  mode: 'offline',
  organizer: '',
  targetAudience: '',
  posterUrl: '',
  headerInvoiceUrl: '',
  contactPersonName1: '',
  contactPhone1: '',
  contactPersonName2: '',
  contactPhone2: '',
  fee: '',
  isActive: true,
  paymentDeadline: '',
};

const AdminEvent = () => {
  const apiUrl = process.env.REACT_APP_API_ENDPOINT;
  const [events, setEvents] = useState([]);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({
    eventCode: "",
    title: "",
    description: "",
    startDate: "",
    endDate: "",
    days: "",
    locationName: "",
    locationAddress: "",
    city: "",
    province: "",
    mode: "",
    organizer: "",
    targetAudience: "",
    posterFile: null,
    posterUrl: "",
    headerInvoiceFile: null,
    headerInvoiceUrl: "",
    contactPersonName1: "",
    contactPhone1: "",
    contactPersonName2: "",
    contactPhone2: "",
    fee: "",
    isActive: true,
    paymentDeadline: ""
  });
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    api.get(`${apiUrl}/api/events?page=${page}&size=${size}`)
      .then(res => {
        setEvents(res.data.content);
        setTotalPages(res.data.totalPages);
      });
  }, [apiUrl, page, size, showModal]);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleFileChange = e => {
    const { name, files } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: files[0]
    }));
  };

  const openCreate = () => {
    setForm(defaultForm);
    setEditId(null);
    setShowModal(true);
  };

  const openEdit = (event) => {
    setForm({
      ...event,
      startDate: event.startDate || '',
      endDate: event.endDate || '',
      fee: event.fee || '',
      isActive: event.isActive ?? true,
      paymentDeadline: event.paymentDeadline || '',
    });
    setEditId(event.id);
    setShowModal(true);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const data = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (key === "posterFile" && value) {
        data.append("poster", value);
      } else if (key === "headerInvoiceFile" && value) {
        data.append("headerInvoice", value);
      } else if (key !== "posterFile" && key !== "headerInvoiceFile") {
        data.append(key, value ?? "");
      }
    });
    try {
      if (editId) {
        await api.put(`${apiUrl}/api/events/${editId}`, data, { headers: { "Content-Type": "multipart/form-data" } });
      } else {
        await api.post(`${apiUrl}/api/events`, data, { headers: { "Content-Type": "multipart/form-data" } });
      }
      setShowModal(false);
    } catch (err) {
      alert("Gagal simpan event");
    }
  };

  const handleDelete = async id => {
    if (!window.confirm('Hapus event ini?')) return;
    try {
      await api.delete(`${apiUrl}/api/events/${id}`);
      setShowModal(false);
      api.get(`${apiUrl}/api/events?page=${page}&size=${size}`)
        .then(res => {
          setEvents(res.data.content);
          setTotalPages(res.data.totalPages);
        });
    } catch (err) {
      alert('Gagal hapus event');
    }
  };

  const setPageListItems = (event) => {
    const value = parseInt(event.target.getAttribute('data-value'), 10);
    setSize(value);
    setPage(0);
  };

  return (
    <div className="page-wrapper">
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title">Event Management</h2>
            </div>
            <div className="col-auto ms-auto d-print-none">
              <button className="btn btn-primary" onClick={openCreate}>
                Create Event
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="page-body">
        <div className="container-xl">
          <div className="card">
            <div className="table-responsive">
              <table className="table card-table table-vcenter text-nowrap datatable table-hover">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Event Code</th>
                    <th>Title</th>
                    <th>Start</th>
                    <th>End</th>
                    <th>Kategori</th>
                    <th>Location</th>
                    {/* <th>Biaya Event</th> */}
                    <th>Active</th>
                    <th>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {events.length === 0 ? (
                    <tr>
                      <td colSpan={10} className="text-center">Data tidak ditemukan</td>
                    </tr>
                  ) : events.map((ev, idx) => (
                    <tr key={ev.id}>
                      <td>{page * size + idx + 1}</td>
                      <td>{ev.eventCode}</td>
                      <td>{ev.title}</td>
                      <td>{ev.startDate}</td>
                      <td>{ev.endDate}</td>
                      <td>{ev.mode}</td>
                      <td>{ev.locationName}</td>
                      {/* <td>{ev.fee}</td> */}
                      <td>{ev.isActive ? 'Yes' : 'No'}</td>
                      <td>
                        <button className="btn btn-sm btn-warning me-1" onClick={() => openEdit(ev)}>Edit</button>
                        <button className="btn btn-sm btn-danger" onClick={() => handleDelete(ev.id)}>Delete</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            
              <div className="card-footer d-flex align-items-center">
                <div className="dropdown">
                  <a className="btn dropdown-toggle" data-bs-toggle="dropdown">
                    <span id="page-count" className="me-1">{size}</span>
                    <span>records</span>
                  </a>
                  <div className="dropdown-menu">
                    {[2,10, 20, 50, 100].map(val => (
                      <a className="dropdown-item" onClick={setPageListItems} data-value={val} key={val}>{val} records</a>
                    ))}
                  </div>
                </div>
                <ul className="pagination m-0 ms-auto">
                  <li className={`page-item${page === 0 ? ' disabled' : ''}`}>
                    <a className="page-link" href="#" tabIndex="-1" aria-disabled={page === 0}
                      onClick={e => { e.preventDefault(); if (page > 0) setPage(page - 1); }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        className="icon icon-1">
                        <path d="M15 6l-6 6l6 6" />
                      </svg>
                      prev
                    </a>
                  </li>
                  {[...Array(totalPages)].map((_, idx) => (
                    <li key={idx} className={`page-item${page === idx ? ' active' : ''}`}>
                      <a className="page-link" href="#" onClick={e => { e.preventDefault(); setPage(idx); }}>{idx + 1}</a>
                    </li>
                  ))}
                  <li className={`page-item${page === totalPages - 1 ? ' disabled' : ''}`}>
                    <a className="page-link" href="#" aria-disabled={page === totalPages - 1}
                      onClick={e => { e.preventDefault(); if (page < totalPages - 1) setPage(page + 1); }}>
                      next
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        className="icon icon-1">
                        <path d="M9 6l6 6l-6 6" />
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>


          </div>
        </div>
      </div>

      {/* Modal Create/Edit */}
      {showModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.3)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="modal-header">
                  <h5 className="modal-title">{editId ? 'Edit Event' : 'Create Event'}</h5>
                  <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Event Code</label>
                      <input type="text" className="form-control" name="eventCode" value={form.eventCode} onChange={handleChange} required />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Title</label>
                      <input type="text" className="form-control" name="title" value={form.title} onChange={handleChange} required />
                    </div>
                    <div className="col-md-12 mb-3">
                      <label className="form-label">Description</label>
                      <textarea className="form-control" name="description" value={form.description} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Start Date</label>
                      <input type="date" className="form-control" name="startDate" value={form.startDate} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">End Date</label>
                      <input type="date" className="form-control" name="endDate" value={form.endDate} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Days</label>
                      <input type="text" className="form-control" name="days" value={form.days} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Location Name</label>
                      <input type="text" className="form-control" name="locationName" value={form.locationName} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Payment Deadline</label>
                      <input type="date" className="form-control" name="paymentDeadline" value={form.paymentDeadline} onChange={handleChange} />
                      <small className="form-hint">Tanggal ini akan muncul di invoice sebagai batas akhir pembayaran.</small>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Location Address</label>
                      <textarea className="form-control" name="locationAddress" value={form.locationAddress} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">City</label>
                      <input type="text" className="form-control" name="city" value={form.city} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Province</label>
                      <input type="text" className="form-control" name="province" value={form.province} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Kategori event</label>
                      <select className="form-select" name="mode" value={form.mode} onChange={handleChange} required>
                        <option value="">Pilih Mode</option>
                        <option value="offline">Offline</option>
                        <option value="online">Online</option>
                        <option value="hybrid">Hybrid</option>
                        <option value="online/offline">Online/Offline</option>
                        <option value="⁠online/offline/hybrid">⁠Online/Offline/Hybrid</option>
                      </select>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Organizer</label>
                      <input type="text" className="form-control" name="organizer" value={form.organizer} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Target Audience</label>
                      <textarea className="form-control" name="targetAudience" value={form.targetAudience} onChange={handleChange} />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Poster</label>
                      <input 
                            type="file" 
                            className="form-control" 
                            name = "posterFile"
                            accept=".jpg,.jpeg,.png" 
                            onChange={handleFileChange} 
                      />
                      {form.posterUrl && (
                        <div className="mt-2">
                          <a
                            href={`${apiUrl}/api/public/displayimage/${form.posterUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Lihat Poster
                          </a>
                        </div>
                      )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Image Header Invoice</label>
                      <input 
                        type="file" 
                        className="form-control" 
                        name="headerInvoiceFile"
                        accept=".jpg,.jpeg,.png" 
                        onChange={handleFileChange} 
                      />
                      {form.headerInvoiceUrl && (
                        <div className="mt-2">
                          <a
                            href={`${apiUrl}/api/public/displayimage/${form.headerInvoiceUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Lihat Header Invoice
                          </a>
                        </div>
                      )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Contact Person 1</label>
                      <input type="text" className="form-control" name="contactPersonName1" value={form.contactPersonName1} onChange={handleChange} />
                      <input type="text" className="form-control mt-1" name="contactPhone1" value={form.contactPhone1} onChange={handleChange} placeholder="Phone" />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Contact Person 2</label>
                      <input type="text" className="form-control" name="contactPersonName2" value={form.contactPersonName2} onChange={handleChange} />
                      <input type="text" className="form-control mt-1" name="contactPhone2" value={form.contactPhone2} onChange={handleChange} placeholder="Phone" />
                    </div>
                    {/* <div className="col-md-6 mb-3">
                      <label className="form-label">Biaya Event</label>
                      <input type="number" className="form-control" name="fee" value={form.fee} onChange={handleChange} />
                    </div> */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Active</label>
                      <input type="checkbox" name="isActive" checked={form.isActive} onChange={handleChange} />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">{editId ? "Update" : "Create"}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminEvent;